import api from '../api'

const initialState = { data: {
    cheques: [], 
    vouchers: [], 
    jokerProducts: [], 
    jokerPackages: [], // old jokers
    swapperJokerPackages: [], 
    swapperTokenPackages: [], 
    diamondPackages: [], 
    mtsPointPackages: [],
} };

export const shop = {
    namespaced: true,
    state: initialState,
    actions: {
        getShop({ commit }, cache){
            if((cache == undefined || cache == false) && this.state.data != null) 
                return Promise.resolve(this.state.data);

            return api.shop()
                .then(response => {
                    commit('getShop', response.data);
                    return Promise.resolve(response.data);
                })
                .catch(error => {
                    api.baseErrorHendler(error);
                    commit('getShopFailure');
                    return Promise.reject(error);
                });
        },
    },
    mutations: {
        getShopFailure(state) {
            state.data = null;
        },
        getShop(state, data) {
            Object.keys(state.data).forEach((key, index) => {
                state.data[key] = data[key] != undefined ? data[key] : [];
            });
        },
    }
};